import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { media, Heading, Text } from '@elseu/sdu-titan';
import styled, { css } from 'styled-components';
import { Button } from '../../components/Button/Button.js';
import { Section, getSectionSpacing } from '../Section/Section.js';

var StyledSectionHeader = styled(Section)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n"], ["\n  background: ", ";\n"])), function (_a) {
  var background = _a.background,
    theme = _a.theme;
  return background === 'sand' ? theme.designTokens.colors.secondary10 : theme.designTokens.colors.grey0;
});
var ContentWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme,
    collage = _a.collage;
  return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    padding: ", ";\n\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    padding: ", ";\n\n    ", "\n  "])), theme.spacing[8], theme.spacing[4], media.greaterThan('s')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n    "], ["\n    ", "\n    "])), collage ? "display: grid; grid-template-columns: 1fr 1fr;" : getSectionSpacing({
    theme: theme,
    yPadding: [4, 8, 12, 24],
    xPadding: [4, 8, 12, 24]
  })));
});
var Header = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme,
    collage = _a.collage;
  return css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    flex: 1;\n    margin-bottom: ", ";\n\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    flex: 1;\n    margin-bottom: ", ";\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), theme.spacing[8], media.greaterThan('s')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      margin-top: auto;\n      margin-bottom: auto;\n      ", "\n    "], ["\n      margin-top: auto;\n      margin-bottom: auto;\n      ", "\n    "])), collage && "\n        grid-column: 1 / 2;\n        width: 100%;\n        justify-self: start;\n        padding-left: ".concat(theme.spacing[4], ";\n        justify-content: center;\n        display: flex;\n        min-height: 580px;\n        flex-direction: column;\n      ")), media.greaterThan('m')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), collage && "padding-left: ".concat(theme.spacing[8], ";")), media.greaterThan('l')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), collage && "\n        justify-self: end;\n        max-width: 621px;\n      "));
});
var ButtonsWrapper = styled.ul(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    margin-top: ", ";\n    gap: ", ";\n    flex-flow: row wrap;\n  "], ["\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    margin-top: ", ";\n    gap: ", ";\n    flex-flow: row wrap;\n  "])), theme.spacing[8], theme.spacing[4]);
});
var ButtonWrapper = styled.li(templateObject_12 || (templateObject_12 = __makeTemplateObject([""], [""])));
var StyledSectionHeaderCollageContainer = styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  flex: 1;\n  align-self: center;\n\n  ", "\n"], ["\n  flex: 1;\n  align-self: center;\n\n  ", "\n"])), media.greaterThan('s')(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    flex-direction: row;\n    max-width: 50vw;\n  "], ["\n    flex-direction: row;\n    max-width: 50vw;\n  "]))));
var Title = styled(Heading)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  -webkit-hyphenate-limit-before: 5;\n  -webkit-hyphenate-limit-after: 5;\n  hyphenate-limit-chars: 11 5 5;\n"], ["\n  -webkit-hyphenate-limit-before: 5;\n  -webkit-hyphenate-limit-after: 5;\n  hyphenate-limit-chars: 11 5 5;\n"])));
var SectionHeader = function (_a) {
  var title = _a.title,
    subtitle = _a.subtitle,
    buttons = _a.buttons,
    collage = _a.collage,
    background = _a.background,
    name = _a.name,
    reference = _a.reference;
  return jsx(StyledSectionHeader, {
    background: background,
    name: name,
    reference: reference,
    children: jsxs(ContentWrapper, {
      collage: collage,
      children: [jsxs(Header, {
        collage: collage,
        children: [title && jsx(Title, {
          renderAs: "h1",
          heading: collage ? 'h1' : 'h3',
          spaceAfter: 4,
          children: jsx("span", {
            dangerouslySetInnerHTML: {
              __html: title
            }
          })
        }), subtitle && jsx(Text, {
          as: "p",
          type: "paragraphLarge",
          color: "primary80",
          children: subtitle
        }), !!(buttons === null || buttons === void 0 ? void 0 : buttons.length) && jsx(ButtonsWrapper, {
          children: buttons.map(function (_a) {
            var label = _a.label,
              href = _a.href,
              variant = _a.variant,
              external = _a.external;
            return jsx(ButtonWrapper, {
              children: jsx(Button, {
                label: label,
                href: href,
                variant: variant,
                isExternal: external
              })
            }, label);
          })
        })]
      }), collage && jsx(StyledSectionHeaderCollageContainer, {
        children: collage
      })]
    })
  });
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;

export { SectionHeader };
//# sourceMappingURL=SectionHeader.js.map
